import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';

const {
	WrappedInputTextWithLabel,
	Spinner,
	WrappedButton,
	WrappedButtonType,
	InfoBanner,
} = UI;
const {
	Logger,
	Communication,
	PasswordValidation,
	withLayoutAndModalContexts,
	Util,
} = Utils;

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			userName:
				Util.getQueryParamByName('username') ||
				Util.getCookie('print_username') ||
				'',
			token: Util.getQueryParamByName('token', { preservePlus: true }),
			newPassword: '',
			newPasswordError: 0,
			errorMessage: '',
			mask: false,
			showSuccess: false,
			validationError: {
				length: -1,
				letter: -1,
				number: -1,
				specialChar: -1,
				differentFromUsername: -1,
			},
		};
	}

	validatePassword = password => {
		const { userName } = this.state;
		return PasswordValidation.validatePassword(password, userName);
	};

	handleInputChange = e => {
		const validationError = this.validatePassword(e.target.value);
		this.setState({
			newPassword: e.target.value,
			newPasswordError: 0,
			validationError,
		});
	};

	onInputTextBlur = () => {
		const { newPassword } = this.state;

		this.setState({
			errorMessage: newPassword ? '' : 'This field is required',
			newPasswordError: newPassword ? 0 : 1,
		});
	};

	isFormValid = () => {
		const { validationError } = this.state;
		return PasswordValidation.isPasswordValid(validationError);
	};

	onKeyPressEnter = e => {
		const {
			key,
			target: { value },
		} = e;

		if (key === 'Enter' && value !== '') {
			e.preventDefault();

			this.onContinueButtonClick();
		}
	};

	goToSignInView = () => {
		// redirect to Auth0 login page
		const { goToSignInView } = this.props;
		const { showSuccess } = this.state;
		goToSignInView(showSuccess);
	};

	onContinueButtonClick = async () => {
		const { token, newPassword, userName } = this.state;

		// The token only lives in memory; a page refresh loses it.
		if (!token) {
			this.setState({
				errorMessage:
					'Your reset link has expired or was already used. Please request a new one using "Forgot password" on the sign-in page.',
				newPasswordError: 1,
			});
			return;
		}

		Logger.saveActionData('Reset Password Button Clicked');

		this.setState({ mask: true });

		const resetPasswordResponse = await Communication.finishPasswordReset({
			Username: userName,
			Password: token,
			NewPassword: newPassword,
		});

		this.setState({ mask: false });

		if (Communication.isSuccessful(resetPasswordResponse)) {
			this.setState({
				showSuccess: true,
			});
		} else {
			const { ErrorCode, ErrorDescription } = resetPasswordResponse;

			this.setState({
				errorMessage: ErrorDescription,
				newPasswordError: ErrorCode,
			});
		}
	};

	renderContent() {
		const {
			newPassword,
			newPasswordError,
			errorMessage,
			mask,
			validationError,
		} = this.state;
		const { length, letter, number, specialChar, differentFromUsername } =
			validationError;
		return (
			<div className="content">
				<p className="content">Enter your new password.</p>

				<div className="row-container password-input">
					<WrappedInputTextWithLabel
						showErrorBelow
						errorMessage={errorMessage}
						isInputInvalid={!!newPasswordError}
						className="bold-font"
						label="Password"
						uiElementConfig={{
							type: 'password',
							value: newPassword,
							name: 'newPassword',
							onChange: this.handleInputChange,
							onBlur: this.onInputTextBlur,
							onKeyPress: this.onKeyPressEnter,
							required: true,
							dataqa: 'new-password',
						}}
					/>
				</div>
				<div className="password-list">
					<p className="validation-header">A strong password must:</p>
					<ul>
						<li>
							<span className={`affirm ${length === -1 ? 'disabled' : ''}`} />
							Have 15-64 characters
						</li>
						<li>
							<span className={`affirm ${letter === -1 ? 'disabled' : ''}`} />
							Include at least one letter
						</li>
						<li>
							<span className={`affirm ${number === -1 ? 'disabled' : ''}`} />
							Include at least one number
						</li>
						<li>
							<span
								className={`affirm ${specialChar === -1 ? 'disabled' : ''}`}
							/>
							Include at least one special character or space
						</li>
						<li>
							<span
								className={`affirm ${
									differentFromUsername === -1 ? 'disabled' : ''
								}`}
							/>
							Be different from username
						</li>
					</ul>
				</div>
				{mask && <Spinner msg="Verifying account information..." />}
			</div>
		);
	}

	render() {
		const { newPassword, showSuccess } = this.state;

		return (
			<>
				{showSuccess ? (
					<div className="common-authentication auth-reset-password-view success-message-view">
						<div className="form">
							<div className="primary-header">
								Your Password Has Been Successfully Reset
							</div>
							<div className="content">
								<InfoBanner type="affirm">
									<span className="icon-affirm" />
									<p className="info-content">
										Password reset successful. You can log in with your new
										password.
									</p>
								</InfoBanner>
							</div>

							<div className="row-container centered">
								<WrappedButton
									label="Return to login"
									onClick={this.goToSignInView}
									buttonType={WrappedButtonType.goToSignInView}
									dataqa="return-to-login"
								/>
							</div>
						</div>
					</div>
				) : (
					<div className="common-authentication auth-reset-password-view">
						<div className="form">
							<div className="primary-header">Reset Password</div>
							{this.renderContent()}
							<div className="row-container centered">
								<WrappedButton
									className="continue-button"
									label="Change password"
									onClick={this.onContinueButtonClick}
									onKeyPress={this.onKeyPressEnter}
									buttonType={WrappedButtonType.Primary}
									dataqa="save-change-password"
									disabled={!this.isFormValid()}
								/>
							</div>
							<div className="row-container centered">
								<WrappedButton
									label="Cancel"
									buttonType={WrappedButtonType.TertiaryGhost}
									dataqa="cancel-reset-password"
									onClick={this.goToSignInView}
								/>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withLayoutAndModalContexts(ResetPassword);
